export default __webpack_public_path__ + "static/media/022-firefighter.67e74e4e.png";